<div class="row">

  <div class="column1 colmd3" *ngIf="DoctorsList">

    <div class="card paddin-left-5px">

      <div class="card-header wh-header header3 padding-right-32px bk-color-sky padding-bottom-0px">

        <div class="row margin-top10px nav-link-hand">


          <label class="font-weight-bold font-size-14 margin-bottom-0px">
            Visit Register
          </label>



        </div>

        <div class="row">


          <label class=" font-size-13px margin-bottom-0px">
            Doctors List
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">
        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px">
          <!--<input type="search" class="form-control padding-bottom-2px width-230px" placeholder="Search....">-->
          <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>

        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper scroll padding-lrt ">
            <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" *ngFor="let l of pdata" (click)="DoctorListItemSelected(l)">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-9 padding-left-5px">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">{{l.Prefix}}{{l.DisplayName}}</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3 font-size-11px">{{l.Specialty}}</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <!--<div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>-->



          </div>
        </div>

      </div>

    </div>
  </div>



  <div class="column2" *ngIf="SelectedDoctor">
    <div class="padding-right-0px background-white">
      <div class="">

        <div class="card">



          <div class="card-header background-white border-bottom-0 padding-bottom-0px pad5">
            <div class="row">
              <div class="col-md-1 margin-left-10px">
                <div class="row">
                  <a class="user-image-circle-65px">
                    <img class="img3" src="DR SITARAM.jpg">
                  </a>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row a1">
                  <label class="margin-bottom-0px f2">{{SelectedDoctorData.DisplayName}}</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
                </div>
                <div class="row a1">
                  <label class="margin-bottom-0px f3">{{SelectedDoctorData.Specialty}}</label>
                </div>

              </div>

              <div class=" offset-md-3 col-md-4 col-sm-3 padding-right padding-left-0px margin-top-auto margin-bottom-auto margin-left-auto">
                <div class="form-group  margin-bottom-5px">
                  <div class="row">
                    <div class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="DecrementDate()">
                      <a title="Previous" class="nav-link-hand">
                        <i class="fas fa-caret-left margin-top-3px  font-size-24px"></i>
                      </a>
                    </div>

                    <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

          <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
        </div>-->

                    <div class="col-md-7 col-sm-4 padding-l-0px padding-right-9px">
                      <div class="date-form">
                        <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                               name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                               (ngModelChange)="dataChanged($event)">

                        <a (click)="d.toggle()" class="nav-link-hand">
                          <span class="date-icon font-size-16px top-11px "><i class="far fa-calendar-alt data-color-new"></i></span>

                        </a>

                      </div>



                    </div>
                    <div class="col-md-1  margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="IncrementDate()">
                      <a title="Next" class="nav-link-hand">
                        <i class="fas fa-caret-right margin-top-3px  font-size-24px "></i>
                      </a>
                    </div>

                  </div>

                </div>
              </div>


            </div>


          </div>

          <div class="card-body background-white padding-top-2px padding-left-5px padding-right-5px">


            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px padding-left-0px">
              <div class="row">
                <div class="col-md-8 label padding-right-0px">
                  <div class="line-appoinment2"></div>
                  <div class="font-size-20px" style="display:inline-block;">Appointments</div>

                  <div class="line-appoinment2"></div>
            
                </div>
                <div class="col-md-4 padding-left-0px padding-right-23px">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange1($event)"></search-list>
                </div>

              </div>
              <div class="chatsd product-chart-wrapper product-chat-height-562 agreement-chart-wrapper ps2 padding-lrt ">
                <div class="table-component b1" *ngIf="CurrentDoctorAppointmentsByDoctorcodeController">
                  <div class="table-responsive overflow-x">


                    <table class="table table-striped margin-left-zero"
                           cols="auto,2*,*,*,*,*,*,*">

                      <thead class="">
                        <tr>


                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            PID
                          </th>


                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            Name
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            Age
                          </th>

                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            Sex
                          </th>

                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            Phone
                          </th>
                          <th class="border-top0 padding-top-4px padding-bottom-4px">
                            Status
                          </th>



                        </tr>
                      </thead>

                      <tbody class="table-body">
                        <!--<div *ngFor="let l of CurrentDoctorAppointmentsByDoctorcodeController"
                           >-->
                        <tr *ngFor="let l of pdata1" (click)="AppointmentsListItemSelected(l)">

                          <td class="f3 padding-top-4px padding-bottom-4px">{{l.PatientFormattedCode}}</td>
                          <td class="f3 padding-top-4px padding-bottom-4px">{{l.PatientName}}</td>
                          <td class="f3 padding-top-4px padding-bottom-4px">
                            {{l.Age}}

                          </td>
                          <td class="f3 padding-top-4px padding-bottom-4px"> {{l.Gender}}</td>
                          <td class="f3 padding-top-4px padding-bottom-4px">{{l.Telephone1}}</td>
                          <td class="f3 padding-top-4px padding-bottom-4px">

                            <div [ngSwitch]="l.AppointmentStatus">


    <a data-toggle="tooltip" data-placement="bottom" title="Pending">

      <i *ngSwitchCase="'Pending'"
         class="fas fa-circle gray nav-link-hand font-size-14">
      </i>
    </a>

    <a data-toggle="tooltip" data-placement="bottom" title="Checked In">
      <i *ngSwitchCase="'CHECKIN'"
         class="fas fa-circle color-Checkin nav-link-hand font-size-14">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Enc Start">
      <i *ngSwitchCase="'ENCSTART'"
         class="fas fa-circle color-Assign nav-link-hand font-size-14">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Enc End">
      <i *ngSwitchCase="'ENCEND'"
         class="fas fa-circle color-Encend nav-link-hand font-size-14">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="Checked Out">
      <i *ngSwitchCase="'CHECKOUT'"
         class="fas fa-circle color-checkout  nav-link-hand font-size-14">
      </i>
    </a>
    <a data-toggle="tooltip" data-placement="bottom" title="No Show">
      <i *ngSwitchCase="'NOSHOW'"
         class="fas fa-circle color-Rejected  nav-link-hand font-size-14">
      </i>
    </a>




    <a data-toggle="tooltip" data-placement="bottom" title="Pending">
      <i *ngSwitchDefault
         class="fas fa-circle color-cyan nav-link-hand font-size-14">
      </i>
    </a>
  </div>
                            <!--<a data-toggle="tooltip" data-placement="bottom" title="Checked In">
                              <i
                                 class="fas fa-circle color-Checkin nav-link-hand font-size-14">
                              </i>
                            </a>
                          </td>-->


                        </tr>
                 





                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>




          </div>
        </div>

      </div>
    </div>
  </div>





  <div class="column3" *ngIf="SelectedPatient">

    <div class="card height-100pe">

      <div class="card-header wh-header header3 bk-color-sky padding-bottom-0px padding-top-3px">

        <div class="row nav-link-hand">

          <label class="wh-header font-weight-normal labcolor margin-left-10px border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky font-size-14 color-Assign">
            Selected Appointment
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">

        <div *ngIf="SelectedAppointmentDetails"
             class="chatsd product-chart-wrapper product-chat-height-600 agreement-chart-wrapper padding-lrt ">

          <div class="row margin-left-0px margin-right-0px">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row">
                <div class="col-md-2 padding-top-5px padding-left-25px">
                  <div class="row">

                    <img class="user-image-circle-65px img4" src="Thor.jpg">

                  </div>

                </div>
                <div class="col-md-9">
                  <div class="row a1">

                    <label class="margin-bottom-0px f2">{{SelectedApptData.PatientName}}</label>
                  </div>

                  <div class="row a1">
                    <label class="margin-bottom-0px f3">{{SelectedAppointmentDetails.Age}} Years, {{SelectedAppointmentDetails.Gender}}</label>
                  </div>

                  <div class="row a1">
                    <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> {{SelectedAppointmentDetails.Telephone1}}</label>
                  </div>
                  <div class="row a1">
                    <label class="margin-bottom-0px f3">{{SelectedAppointmentDetails.PatientFormattedCode}}</label>
                  </div>

                </div>

              </div>






            </div>
          </div>


          <div class="row margin-left-0px margin-right-0px">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row schedule-time-badge">

                <div class="col-md-7">
                  <div class="row margin-left-0px">

                    <label class="margin-bottom-0px f2">{{SelectedAppointmentDetails.VisitType}}</label>
                  </div>

                  <div class="row margin-left-0px">
                    <label class="margin-bottom-0px font-size-14 ">{{SelectedAppointmentDetails.StartTime | date:'MMM-dd-yyyy'}} </label>
                  </div>

                </div>
                <div class="col-md-4 margin-left-auto">
                  <div class="row margin-left-0px">

                   
                  </div>

                  <div class="row margin-left-0px text-align-right">
                    <label class="margin-bottom-0px font-size-14 ">{{SelectedAppointmentDetails.StartTime | date: 'mediumTime'}} </label>
                  </div>

                </div>
              </div>

            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px" *ngIf="!SelectedAppointmentDetails.NoShowStatus">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row margin-top-3px">

                <div class=" col-md-12 padding-left-0px">
                  <div class="row a1 border-style-visit">
                    <div class="col-md-4 padding-right-0px margin-top-auto margin-bottom-auto">
                      <label class="margin-bottom-0px  color-gray">Check-In</label>
                    </div>
                    <div class="col-md-1 padding-right-0px margin-top-7px padding-left-0px">
                      <!--<label class="switch margin-bottom-0px">
                <input type="checkbox" class="checkbox2" (click)=" toggle()">

              </label>-->
                      <input type="checkbox" class="checkbox2" (change)="onSubmit('CHECKIN', $event)"
                             [(ngModel)]="SelectedAppointmentDetails.CheckInStatus">
                    </div>

                  </div>


                </div>


              </div>






            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px" *ngIf="!SelectedAppointmentDetails.NoShowStatus">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row margin-top-3px">

                <div class="col-md-12 padding-left-0px">
                  <div class="row a1 border-style-visit">
                    <div class="col-md-4 padding-right-0px margin-top-auto margin-bottom-auto">
                      <label class="margin-bottom-0px  color-gray">Enc-Start</label>
                    </div>
                    <div class="col-md-1 padding-right-0px margin-top-7px padding-left-0px">
                      <!--<label class="switch margin-bottom-0px">
                <input type="checkbox" class="checkbox2" (click)=" toggle1()">
                <span class="slider1 round"></span>
              </label>-->
                      <input type="checkbox" class="checkbox2" name="SelectedAppointmentDetails.EncounterStartStatus" (change)="onSubmit('ENCSTART', $event)"
                             [(ngModel)]="SelectedAppointmentDetails.EncounterStartStatus">
                    </div>

                  </div>



                </div>


              </div>






            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px" *ngIf="!SelectedAppointmentDetails.NoShowStatus">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row margin-top-3px">

                <div class="col-md-12 padding-left-0px">
                  <div class="row a1 border-style-visit">
                    <div class="col-md-4 padding-right-0px margin-top-auto margin-bottom-auto">
                      <label class="margin-bottom-0px  color-gray ">Enc-end</label>
                    </div>
                    <div class="col-md-1 padding-right-0px margin-top-7px padding-left-0px">
                      <!--<label class="switch margin-bottom-0px">
                <input type="checkbox" class="checkbox2" (click)="toggle2">
                <span class="slider1 round"></span>
              </label>-->
                      <input type="checkbox" class="checkbox2" name="SelectedAppointmentDetails.EncounterEndStatus" (change)="onSubmit('ENCEND', $event)"
                             [(ngModel)]="SelectedAppointmentDetails.EncounterEndStatus">
                    </div>

                  </div>



                </div>


              </div>






            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px" *ngIf="!SelectedAppointmentDetails.NoShowStatus">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row margin-top-3px">

                <div class="col-md-12 padding-left-0px">
                  <div class="row a1 border-style-visit">
                    <div class="col-md-4 padding-right-0px margin-top-auto margin-bottom-auto">
                      <label class="margin-bottom-0px  color-gray ">Check-out</label>
                    </div>
                    <div class="col-md-1 padding-right-0px margin-top-7px padding-left-0px">
                      <!--<label class="switch margin-bottom-0px">
                <input type="checkbox" class="checkbox2" (click)="toggle3()">
                <span class="slider1 round"></span>
              </label>-->
                      <input type="checkbox" class="checkbox2" name="SelectedAppointmentDetails.CheckOutStatus" (change)="onSubmit('CHECKOUT', $event)"
                             [(ngModel)]="SelectedAppointmentDetails.CheckOutStatus">
                    </div>

                  </div>



                </div>


              </div>






            </div>
          </div>

          <div class="row margin-left-0px margin-right-0px" *ngIf="!SelectedAppointmentDetails.CheckInStatus">
            <div class="col-md-12 margin-top-5px margin-bottom-5px">

              <div class="row margin-top-3px">

                <div class="col-md-12 padding-left-0px">
                  <div class="row a1 border-style-visit">
                    <div class="col-md-4 padding-right-0px margin-top-auto margin-bottom-auto">
                      <label class="margin-bottom-0px  color-gray ">No Show</label>
                    </div>
                    <div class="col-md-1 padding-right-0px margin-top-7px padding-left-0px">
                      <!--<label class="switch margin-bottom-0px">
                <input type="checkbox" class="checkbox2" (click)="toggle3()">
                <span class="slider1 round"></span>
              </label>-->
                      <input type="checkbox" class="checkbox2" name="SelectedAppointmentDetails.NoShowStatus" (change)="onSubmit('NOSHOW', $event)"
                             [(ngModel)]="SelectedAppointmentDetails.NoShowStatus">
                    </div>

                  </div>



                </div>


              </div>






            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</div>



